import { Asset } from "expo-asset";
import { Platform, type ImageSourcePropType } from "react-native";

const brandBackdropModule = require("../../assets/rm-background.png");
const brandBackdropAsset = Asset.fromModule(brandBackdropModule);
const ANDROID_BRAND_BACKDROP_URI = "recital-master-asset://brand-backdrop";

// Metro gives embedded assets an HTTP `uri`, while Expo Updates-backed
// Release builds deliberately leave that remote URI empty and expose the
// bundled file through `localUri`. Prefer the on-device copy whenever it is
// available so Debug and Release paint the same atmosphere.
export const BRAND_BACKDROP_URI =
  Platform.OS === "android"
    ? ANDROID_BRAND_BACKDROP_URI
    : brandBackdropAsset.localUri ?? brandBackdropAsset.uri;

/**
 * React Native's Android image pipeline resolves the numeric Metro asset
 * module against the active embedded/OTA asset map. Do not turn that module
 * into a file:// URL first: release updates can keep the asset in an
 * Expo-managed location that native URI loaders do not accept directly.
 */
export function brandBackdropSource(uri: string): ImageSourcePropType {
  return uri === ANDROID_BRAND_BACKDROP_URI
    ? brandBackdropModule
    : { uri };
}
